export default __webpack_public_path__ + "static/PlayfairDisplay-BoldItalic-451bf906b2d88a149f6d73c8d5453ca7.woff";